module.exports = __webpack_public_path__ + "img/lose_lottery1_mall.58e662fb.png";